import NextImage from 'next/image'
import placeholder from './placeholder.svg'

interface PlaceholderProps {
  width?: number
  height?: number
  className?: string
}

function Placeholder ({ width, height, className }: PlaceholderProps) {
  return (
    <NextImage
      src={placeholder}
      alt="placeholder"
      width={width || 200}
      height={height || 200}
      className={className}
    />
  )
}

export default Placeholder
